import { inject, injectable } from 'inversify'
import { RequestHandler, requestHandler } from 'mediatr-ts'

import { TrackingManager } from '@infrastructure/managers/tracking/tracking-manager'

import { TrackMetricCommand } from './command'

@requestHandler(TrackMetricCommand)
@injectable()
export class TrackMetricCommandHandler implements RequestHandler<TrackMetricCommand, void> {
  constructor(@inject(TrackingManager) private readonly trackingManager: TrackingManager) {}

  public handle(value: TrackMetricCommand): Promise<void> {
    this.trackingManager.track(value.type, value.action, value.properties)
    return Promise.resolve()
  }
}
